export const version = '2.52.0';
//# sourceMappingURL=version.js.map